import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    firstName: {
      label: {
        id: 'properties.given_name',
        defaultMessage: 'First name',
        description: 'label of the first name field',
      },
    },
    lastName: {
      label: {
        id: 'properties.family_name',
        defaultMessage: 'Last name',
        description: 'label of the last name field',
      },
    },
    lastNamePrefix: {
      label: {
        id: 'properties.additional_name',
        defaultMessage: 'Last name prefix',
        description: 'label of the last name prefix field',
      },
    },
    company: {
      label: {
        id: 'properties.company',
        defaultMessage: 'Company',
        description: 'label of the company field',
      },
    },
    phoneNumber: {
      label: {
        id: 'properties.phoneNumber',
        defaultMessage: 'Phone number',
        description: 'label of the phone number field',
      },
    },
    audience: {
      label: {
        id: 'properties.audience',
        defaultMessage: 'Audience',
        description: 'label of the audience field',
      },
    },
    email: {
      label: {
        id: 'properties.email',
        defaultMessage: 'Email',
        description: 'label of the email field',
      },
    },
    tags: {
      label: {
        id: 'properties.tags',
        defaultMessage: 'Tags',
        description: 'label of the tags field',
      },
    },
    primaryBillingAddress: {
      label: {
        id: 'properties.primaryBillingAddress',
        defaultMessage: 'Primary billing address',
        description: 'label of the primary billing address field',
      },
    },
    primaryShippingAddress: {
      label: {
        id: 'properties.primaryShippingAddress',
        defaultMessage: 'Primary shipping address',
        description: 'label of the primary shipping address field',
      },
    },
    primaryPhoneNumber: {
      label: {
        id: 'properties.primaryPhoneNumber',
        defaultMessage: 'Primary phone number',
        description: 'label of the primary phone number field',
      },
    },
    primaryOrganisation: {
      label: {
        id: 'properties.primaryOrganisation',
        defaultMessage: 'Primary organisation',
        description: 'label of the primary organisation field',
      },
    },
  },
  feedback: {
    emailAddressAlreadyUsed: {
      id: 'forms.contactForm.feedback.emailAddressAlreadyUsed',
      defaultMessage:
        'The email address you entered is already in use. Use a different address or edit the existing contact.',
      description: 'error message on the contact form when the given email address us already used',
    },
  },
};

export default defineMessages(translations);
